import { render, staticRenderFns } from "./Stretch_Break.vue?vue&type=template&id=4db15c37"
import script from "./Stretch_Break.vue?vue&type=script&lang=js"
export * from "./Stretch_Break.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports